export default __webpack_public_path__ + "static/media/icon-notification.c9eca38f.svg";